angular.module('bmsApp.form', []);
angular.module('bmsApp.form').factory('FormOptionsSvc', function ($http, $log, $window, $q) {

	return {
		title: function () {
			var deferred = $q.defer();
			
			// spoof response
			var response = {
				data: {
					success:true,
					message:'',
					options: [
						{
							value:'Mr',
							label:'Mr'
						},
						{
							value:'Mrs',
							label:'Mrs'
						},
						{
							value:'Miss',
							label:'Miss'
						},
						{
							value:'Ms',
							label:'Ms'
						},
						{
							value:'Dr',
							label:'Dr'
						},
						{
							value:'Reverend',
							label:'Reverend'
						},
						{
							value:'Lord',
							label:'Lord'
						},
						{
							value:'Lady',
							label:'Lady'
						},
						{
							value:'Sir',
							label:'Sir'
						},
						{
							value:'Catholic Father',
							label:'Catholic Father',
						},
						{
							value:'Dame',
							label:'Dame',
						}
					]
				}
			};
			
			deferred.resolve(response);
			
			return deferred.promise;
		},
		
		gender: function () {
			var deferred = $q.defer();
			
			// spoof response
			var response = {
				data: {
					success:true,
					message:'',
					options: [
						{
							value:'Male',
							label:'Male'
						},
						{
							value:'Female',
							label:'Female'
						}
					]
				}
			};
			
			deferred.resolve(response);
			
			return deferred.promise;
		},
		
		startingLocationType: function () {
			var deferred = $q.defer();
			
			// spoof response
			var response = {
				data: {
					success:true,
					message:'',
					options: [
						{
							value:'office',
							label:'Office'
						},
						{
							value:'home',
							label:'Home'
						},
						{
							value:'custom postcode',
							label:'Custom Postcode'
						}
					]
				}
			};
			
			deferred.resolve(response);
			
			return deferred.promise;
		}
	};

});